import React from "react";
import ReactDOM from "react-dom/client";
import {WagmiProvider} from "wagmi";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {RainbowKitProvider, darkTheme} from "@rainbow-me/rainbowkit";
import {BrowserRouter, Routes, Route} from "react-router-dom";

import "@rainbow-me/rainbowkit/styles.css";
import "./index.css";

import {wagmiConfig} from "./lib/wagmi";
import {ritualChain} from "./lib/chain";
import App from "./App";
import {Home} from "./pages/Home";
import {Console} from "./pages/Console";
import {Filings} from "./pages/Filings";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {refetchOnWindowFocus: false, retry: 1},
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          theme={darkTheme({
            accentColor: "#f95d10",
            accentColorForeground: "#fff6ed",
            borderRadius: "small",
            overlayBlur: "small",
          })}
          initialChain={ritualChain}
        >
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<App />}>
                <Route index element={<Home />} />
                <Route path="console" element={<Console />} />
                <Route path="filings" element={<Filings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
